import type { IconType } from 'react-icons'
import {
  HiOutlineHome,
  HiOutlineUsers,
  HiOutlineBuildingOffice2,
  HiOutlineAcademicCap,
  HiOutlineUserGroup,
  HiOutlineBriefcase,
  HiOutlineRectangleStack,
  HiOutlineExclamationTriangle,
  HiOutlineCalendarDays,
  HiOutlineClock,
  HiOutlineClipboardDocumentCheck,
  HiOutlineDocumentText,
  HiOutlineChartBarSquare,
  HiOutlineMapPin,
  HiOutlineMagnifyingGlass,
  HiOutlineCog6Tooth,
  HiOutlineBuildingLibrary,
  HiOutlineFlag,
  HiOutlineInboxArrowDown,
  HiOutlineArchiveBoxArrowDown,
} from 'react-icons/hi2'
import type { Permission } from '@/types'

export interface NavItem {
  label: string
  to: string
  icon: IconType
  permission: Permission
  badgeKey?: 'grievances' | 'tasks' | 'meetings' | 'notifications'
  group: 'main' | 'crm' | 'operations' | 'system'
}

export const NAV_GROUPS: { key: NavItem['group']; label: string }[] = [
  { key: 'main', label: 'Overview' },
  { key: 'crm', label: 'Relationships' },
  { key: 'operations', label: 'Operations' },
  { key: 'system', label: 'Intelligence & Admin' },
]

export const NAV_ITEMS: NavItem[] = [
  { label: 'Dashboard', to: '/dashboard', icon: HiOutlineHome, permission: 'dashboard:view', group: 'main' },

  { label: 'Contacts', to: '/contacts', icon: HiOutlineUsers, permission: 'stakeholders:view', group: 'crm' },
  { label: 'Directory', to: '/directory', icon: HiOutlineBuildingOffice2, permission: 'businesses:view', group: 'crm' },
  { label: 'Skills Registry', to: '/skills', icon: HiOutlineAcademicCap, permission: 'skills:view', group: 'crm' },
  { label: 'Departments', to: '/departments', icon: HiOutlineBuildingLibrary, permission: 'departments:view', group: 'crm' },
  { label: 'Political Hierarchy', to: '/political-hierarchy', icon: HiOutlineFlag, permission: 'political:view', group: 'crm' },

  { label: 'Front Desk', to: '/front-desk', icon: HiOutlineInboxArrowDown, permission: 'grievances:view', badgeKey: 'frontDesk', group: 'operations' },
  { label: 'Opportunities', to: '/opportunities', icon: HiOutlineBriefcase, permission: 'opportunities:view', group: 'operations' },
  { label: 'Projects', to: '/projects', icon: HiOutlineRectangleStack, permission: 'projects:view', group: 'operations' },
  { label: 'Grievances', to: '/issues', icon: HiOutlineExclamationTriangle, permission: 'grievances:view', badgeKey: 'grievances', group: 'operations' },
  { label: 'Meetings', to: '/meetings', icon: HiOutlineUserGroup, permission: 'meetings:view', badgeKey: 'meetings', group: 'operations' },
  { label: 'Calendar', to: '/calendar', icon: HiOutlineCalendarDays, permission: 'calendar:view', group: 'operations' },
  // [Action Management module] — remove this line to uninstall.
  { label: 'Task & Actions', to: '/actions', icon: HiOutlineClipboardDocumentCheck, permission: 'tasks:view', badgeKey: 'tasks', group: 'operations' },

  { label: 'Reports', to: '/reports', icon: HiOutlineChartBarSquare, permission: 'reports:view', group: 'system' },
  { label: 'Data Cleanup', to: '/cleanup', icon: HiOutlineArchiveBoxArrowDown, permission: 'cleanup:view', group: 'system' },
  { label: 'Documents', to: '/documents', icon: HiOutlineDocumentText, permission: 'documents:view', group: 'system' },
  { label: 'Maps', to: '/maps', icon: HiOutlineMapPin, permission: 'maps:view', group: 'system' },
  { label: 'Global Search', to: '/search', icon: HiOutlineMagnifyingGlass, permission: 'search:view', group: 'system' },
  { label: 'Settings', to: '/settings', icon: HiOutlineCog6Tooth, permission: 'settings:view', group: 'system' },
]

export { HiOutlineClock }
